import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { COMPANY } from "@/config";

const NAV = [
  { label: "Diensten", href: "#diensten" },
  { label: "Waarom Sefco", href: "#waarom" },
  { label: "Realisaties", href: "#realisaties" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 border-b ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="header-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3"
        >
          <img src={COMPANY.logo} alt="Sefco logo" className="h-8 md:h-10 w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <button
              key={n.href}
              data-testid={`nav-${n.href.replace("#", "")}`}
              onClick={() => go(n.href)}
              className="text-sm uppercase tracking-[0.15em] text-zinc-300 hover:text-white transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="header-cta"
          onClick={() => go("#contact")}
          className="hidden md:inline-flex items-center bg-sefco-blue hover:bg-sefco-blueHover text-white font-bold text-sm px-6 py-3 tracking-wide transition-colors"
        >
          Offerte aanvragen
        </button>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {NAV.map((n) => (
            <button
              key={n.href}
              data-testid={`mobile-nav-${n.href.replace("#", "")}`}
              onClick={() => go(n.href)}
              className="text-left text-lg font-medium text-zinc-200"
            >
              {n.label}
            </button>
          ))}
          <button
            data-testid="mobile-cta"
            onClick={() => go("#contact")}
            className="mt-2 bg-sefco-blue text-white font-bold px-6 py-4 tracking-wide"
          >
            Offerte aanvragen
          </button>
        </div>
      )}
    </header>
  );
};
